import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AbcCommonEditorsModule } from '@barthauer/abc/common-editors';
import { AbcMessagesModule } from '@barthauer/abc/messages';
import {
  AbcAutoCompleteInputModule,
  AbcTileNavMenuModule,
  AbcUiComponentsModule,
  _AbcFileUploaderComponent,
  _AbcTextAreaComponent,
  _AbcCheckBoxComponent,
  _AbcButtonComponent,
  AbcTextBoxComponent,
  AbcNumberBoxComponent,
  AbcDateBoxComponent,
  AbcBadgeComponent,
} from '@barthauer/abc/ui-components';
import {
  DxButtonGroupModule,
  DxDateBoxModule,
  DxPopupModule,
  DxValidationGroupModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { OkDialogComponent } from '../shared/ok-dialog.component';
import { TaskDetailComponent } from './task-detail/task-detail.component';
import { UploadResultComponent } from './upload-result/upload-result.component';
import { WorkDetailComponent } from './work-detail/work-detail.component';
import { WorkListComponent } from './work-list/work-list.component';
import { WorkNavigationComponent } from './work-navigation/work-navigation.component';
import { WorksRoutingModule } from './works-routing.module';
import { WorksService } from './works.service';
import { WorksComponent } from './works/works.component';
import { AbcMediaGalleryComponent } from 'libs/abc/ui-components/src/lib/specialized/abc-media-gallery/src/lib/abc-media-gallery.component';

@NgModule({
  declarations: [
    WorksComponent,
    WorkListComponent,
    WorkDetailComponent,
    TaskDetailComponent,
    WorkNavigationComponent,
    UploadResultComponent,
    OkDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    WorksRoutingModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatInputModule,
    MatChipsModule,
    MatStepperModule,
    MatExpansionModule,
    MatGridListModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatSortModule,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    ScrollingModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    AbcUiComponentsModule,
    DxButtonGroupModule,
    AbcCommonEditorsModule,
    MatDialogModule,
    AbcMessagesModule,
    AbcAutoCompleteInputModule,
    AbcTileNavMenuModule,
    DxPopupModule,
    DxDateBoxModule,
    DxValidatorModule,
    DxValidationGroupModule,
    _AbcFileUploaderComponent,
    _AbcTextAreaComponent,
    _AbcCheckBoxComponent,
    _AbcButtonComponent,
    AbcTextBoxComponent,
    AbcNumberBoxComponent,
    AbcDateBoxComponent,
    AbcBadgeComponent,
    AbcMediaGalleryComponent,
  ],
  providers: [WorksService],
})
export class WorksModule {}
